import { Box, Button, Typography } from '@mui/material';
import { useAuth } from '../../../providers/auth.provider';

export const MfaBackupCodes = () => {
  const { backupCodes, completeMfa, mfaGate } = useAuth();

  if (!backupCodes) {
    return null;
  }

  const text = backupCodes.join('\n');

  const copyCodes = async () => {
    await navigator.clipboard.writeText(text);
  };

  const downloadCodes = () => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'dishboard-admin-mfa-backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box display="grid" rowGap={2.5}>
      <Typography variant="subtitle1">Save your backup codes</Typography>
      <Typography variant="body2">
        These codes are shown once. Store them next to the authenticator secret.
        Each code can be used only once.
      </Typography>
      {mfaGate?.isServiceAccount ? (
        <Typography variant="body2">
          Put these backup codes in the same shared 1Password item as the
          otpauth URI so the whole team can recover the service account.
        </Typography>
      ) : null}
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 2,
          bgcolor: 'grey.100',
          borderRadius: 1,
          fontFamily: 'monospace',
        }}
      >
        {text}
      </Box>
      <Box display="flex" gap={1}>
        <Button type="button" onClick={copyCodes}>
          Copy
        </Button>
        <Button type="button" onClick={downloadCodes}>
          Download
        </Button>
      </Box>
      <Button
        variant="contained"
        onClick={() => completeMfa()}
        sx={{ minWidth: 160, justifySelf: 'end' }}
      >
        I have saved these codes
      </Button>
    </Box>
  );
};
